//==================================================================================================
//
//==================================================================================================
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { HttpErrorHandler, HandleError } from '../../../http-error-handler.service';

import { AppConst } from '../../../app-const';

import { MGLoginRequest, MGLoginResponse } from '../../../class/api/MGLogin'
import { MGLogoutRequest, MGLogoutResponse } from '../../../class/api/MGLogout'
import { MGPwResetRequest, MGPwResetResponse } from '../../../class/api/MGPwReset'
import { MGSignupRequest, MGSignupResponse } from '../../../class/api/MGSignup'
//==================================================================================================
//
//==================================================================================================
@Injectable({
  providedIn: 'root'
})
//==================================================================================================
//
//==================================================================================================
export class LoginHttpService {
  //================================================================================================
  //  変数定義
  //============================|===================================================================
  private handleError           : HandleError;
  //================================================================================================
  //  コンストラクタ
  //============================|===================================================================
  constructor(
    private http: HttpClient,
    private httpErrorHandler: HttpErrorHandler) {
      this.handleError = this.httpErrorHandler.createHandleError('LoginHttpService');
    }
  //================================================================================================
  //  ログインログ
  //================================================================================================
  login(op_email: string): Observable<MGLoginRequest | MGLoginResponse>{
    let request                 : MGLoginRequest = {
      op_email                    : op_email
    };
    return this.http.post<any>(`${AppConst.BASE_URL}/mg_login`, request)
      .pipe(
        catchError(this.handleError('LoginHttpService login Error : ', request))
      );
  }
  //================================================================================================
  //  ログアウトログ
  //================================================================================================
  logout(op_email: string): Observable<MGLogoutRequest | MGLogoutResponse>{
    let request                 : MGLogoutRequest = {
      op_email                    : op_email
    };
    return this.http.post<any>(`${AppConst.BASE_URL}/mg_logout`, request)
      .pipe(
        catchError(this.handleError('LoginHttpService logout Error : ', request))
      );
  }
  //================================================================================================
  //  パスワードの再設定
  //================================================================================================
  pw_reset(op_email: string): Observable<MGPwResetRequest | MGPwResetResponse>{
    let request                 : MGPwResetRequest = {
      op_email                    : op_email
    };
    return this.http.post<any>(`${AppConst.BASE_URL}/mg_pw_reset`, request)
      .pipe(
        catchError(this.handleError('LoginHttpService pw_reset Error : ', request))
      );
  }
  //================================================================================================
  //  サインインログ
  //================================================================================================
  signup(op_email: string): Observable<MGSignupRequest | MGSignupResponse>{
    let request                 : MGSignupRequest = {
      op_email                    : op_email
    };
    return this.http.post<any>(`${AppConst.BASE_URL}/mg_signup`, request)
      .pipe(
        catchError(this.handleError('LoginHttpService signup Error : ', request))
      );
  }
}
